import styled from 'styled-components';

const HeaderParent = styled.div`
  width: 1136px;
  grid-template-columns: repeat(24, 1fr);
  grid-column-gap: 16px;
  display: grid;
  margin: auto;
  height: 100%;
  grid-template-rows: auto;
  position: relative;
  @media (max-width: 70.95em) {
    width: 728px;
    grid-column-gap: 8px;
  }
`;

export default HeaderParent;
